import { FC } from "react";
import { NotificationType } from "../../../../domain/enums/NotificationTypeEnum";
import CreateIconSVG from "../../../resources/svg/CreateIconSVG";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";

interface ApplicationNewCardProps {
    notification: NotificationDTO;
    onClick: () => void;
}

const ApplicationNewCard: FC<ApplicationNewCardProps> = (props) => {
    const { t } = useTranslation();
    const { upTo800, moreOrEqual800 } = useScreenSize();

    return (
        <div
            onClick={props.onClick}
            className="flex w-full bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.16)] rounded-[10px] py-9 dmax2:py-5 px-10 dmax2:px-4 cursor-pointer transition duration-300"
        >
            <CreateIconSVG className="min-w-8 dmax2:min-w-6 min-h-8 dmax2:min-h-6 text-textFaded mr-6 dmax2:mr-3" />
            <div className="flex flex-col w-full">
                <div className="flex justify-between">
                    <span className="H24B dmax2:H16B text-textWhite text-left max-w-[550px] line-clamp-2">
                        {t(`notifications.${NotificationType.APPLICATION_NEW}`)}
                    </span>
                    {moreOrEqual800 && (
                        <span className="H16 dmax2:H14 text-textFaded">
                            {getNotificationCreatedTime(t, props.notification, true)}
                        </span>
                    )}
                </div>
                <span className="H20B dmax2:H14B text-textWarning text-left mt-4 dmax2:mt-2 [word-break:break-word]">
                    {props.notification.application?.work.title}
                </span>
                {upTo800 && (
                    <span className="H16 dmax2:H14 text-textFaded text-end mt-2">
                        {getNotificationCreatedTime(t, props.notification, true)}
                    </span>
                )}
            </div>
        </div>
    );
};

export default ApplicationNewCard;
